var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{staticClass:"gl-ml-2",attrs:{"variant":_vm.variant}},[_vm._v("\n  "+_vm._s(_vm.draftsCount)+"\n  "),_c('span',{staticClass:"sr-only"},[_vm._v(" "+_vm._s(_vm.n__('draft', 'drafts', _vm.draftsCount))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }